export function topmovesvginit() {
    if (location.pathname == "/") {
        let photos = document.querySelectorAll(".treatment__innerBlockRightRow")
        photos.forEach((photo) => {
            photo.addEventListener("mousemove", (e) => {
                let svg = photo.getElementsByTagName("svg")[0]
                let sx = e.layerX / photo.clientWidth * 40 - 70
                let sy = e.layerY / photo.clientHeight * 20 - 60
                svg.style.transform = "translate(" + sx + "%," + sy + "%)"
            })
        })
    }
}